import ajax from 'ajax'
import { getPhoneCom } from 'phonecom'
import PhoneComUser from 'phone-com-user'
import { LiveReceptionistListCallResponse, LiveReceptionistUsageSummaryResponse } from 'interfaces'
import { ControlledError } from 'errors'

const callApi = async (url, payload = {}, errMessage = '') => {
    await getPhoneCom()
    const res = await ajax.post(
        `${PhoneComUser.getv5ApiRoot()}${url}`,
        payload
    )
    if (res.status !== 200) {
        throw new ControlledError(errMessage || 'Something went wrong')
    }
    return res.data
}

/**
 *
 */
const list = async (filters = {}): Promise<LiveReceptionistListCallResponse> => {
    return callApi(
        '/live-receptionist/list-calls',
        filters,
        'Something went wrong while loading your call list'
    )
}

/**
 *
 */
const getUsageSummary = async (
    filters: { start_date: number, end_date: number }
): Promise<LiveReceptionistUsageSummaryResponse> => {
    return callApi(
        '/live-receptionist/get-usage-summary',
        filters,
        'Something went wrong while loading your script usage summary'
    )
}

/**
 *
 */
const downloadCsv = async (filters) => {
    return callApi(
        '/live-receptionist/export-calls',
        filters,
        'Something went wrong while downloading your csv'
    )
}

/**
 *
 */
export {
    downloadCsv,
    getUsageSummary,
    list
}
